import { useState, useEffect, useMemo } from 'react'
import { Statistic, Progress } from 'antd'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'

dayjs.extend(duration)

const { Timer } = Statistic

export interface CountdownWithProgressProps {
  time?: string
}

export function CountdownWithProgress({ time = '04:00:00' }: CountdownWithProgressProps) {
  const parts = time.split(':').map(Number)
  const totalMs = dayjs
    .duration({ hours: parts[0], minutes: parts[1], seconds: parts[2] })
    .asMilliseconds()

  const targetTime = useMemo(() => Date.now() + totalMs, [totalMs])

  const [remainingMs, setRemainingMs] = useState(totalMs)

  useEffect(() => {
    const timer = setInterval(() => {
      const newRemaining = targetTime - Date.now()
      if (newRemaining <= 0) {
        clearInterval(timer)
        setRemainingMs(0)
      } else {
        setRemainingMs(newRemaining)
      }
    }, 1000)

    return () => clearInterval(timer)
  }, [targetTime])

  const progressPercent = (remainingMs / totalMs) * 100

  const onFinish = () => {
    // TODO: wire countdown completion (notify parent, refetch, etc.)
  }

  return (
    <div className='flex gap-4 items-center'>
      <Timer type='countdown' value={targetTime} onFinish={onFinish} />
      <Progress type='circle' percent={Math.round(progressPercent)} />
    </div>
  )
}
